__turbopack_context__.v({
  "badge": "FileTeaser-module-scss-module__aGhkia__badge",
  "frame": "FileTeaser-module-scss-module__aGhkia__frame",
  "root": "FileTeaser-module-scss-module__aGhkia__root",
});
